import React from 'react';
import { Dialog } from '../lib/dialog';
import { Button } from '../lib/button';
import { Icon } from '../lib/icon';
import { ImportErrorDetail } from '../service/importExportService';

export interface ImportFailedDialogProps {
  open: boolean;
  onClose: () => void;
  errors?: ImportErrorDetail[];
}

export const ImportFailedDialog: React.FC<ImportFailedDialogProps> = ({
  open, onClose, errors = [],
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Icon name="error-notification" style={{ fontSize: 20, color: '#c0392b' }} />
          Import failed
        </span>
      }
      footer={<Button onClick={onClose}>Close</Button>}
    >
      <p style={{ marginBottom: errors.length > 0 ? 16 : 0 }}>
        The file could not be imported. Please review the errors below, correct the file and try again.
      </p>

      {errors.length > 0 ? (
        <div className="message is-danger" style={{ maxHeight: 300, overflowY: 'auto', marginBottom: 0 }}>
          <div className="message-body" style={{ padding: '12px 16px' }}>
            <ul style={{ paddingLeft: 18, margin: 0 }}>
              {errors.map((err, i) => (
                <li key={i} style={{ marginBottom: 6 }}>
                  <strong>{err.location}</strong> — {err.message}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ) : (
        <p className="help is-danger">
          An unexpected error occurred. Please check the file format and try again.
        </p>
      )}
    </Dialog>
  );
};
